import { API } from "@/App";
import { toast } from "sonner";

export const canDeleteReport = (r) => r && r.status !== "sent" && !r.sent_at;

export const restoreReport = async (token, reportId, onChange) => {
  const r = await fetch(`${API}/staff/reports/${reportId}/restore`, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
  const d = await r.json();
  r.ok ? toast.success("Report restored") : toast.error(d.detail || "Could not restore");
  onChange?.();
};

export const deleteReportWithUndo = async (token, report, onChange) => {
  const r = await fetch(`${API}/staff/reports/${report.report_id}`, { method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
  const d = await r.json();
  if (!r.ok) { toast.error(d.detail || "Could not delete"); return false; }
  onChange?.();
  toast(`"${report.title || "Report"}" deleted`, {
    duration: 10000,
    description: "You can also restore it from Recently deleted for 30 days.",
    action: { label: "Undo", onClick: () => restoreReport(token, report.report_id, onChange) },
  });
  return true;
};
